@if (!isLoggedIn() && !windowMode()) {
  <div
    class="flex flex-col items-stretch gap-4 sm:flex-row sm:items-center sm:justify-between sm:gap-6 rounded-lg border border-cp-primary-20 px-6 py-5"
  >
    <p class="m-0 text-sm text-cp-primary-100">
      Logge dich in deinem Kundenportal ein, um deine Berechnung mit deinen Daten vorzubefüllen und in
      deinem Kundenportal zu speichern. Alternativ kannst du als Gast fortfahren.
    </p>
    <button mat-stroked-button class="btn-secondary-sm shrink-0 w-full sm:w-auto" (click)="login()">
      Jetzt einloggen
    </button>
  </div>
}
